// extracted by mini-css-extract-plugin
export default {"card":"ChargePointTransactionList_card__i29q7"};